import React, { useState, useEffect } from "react";
import {Button, Col, Modal, Row, Spin, Form, notification} from "antd";
import InputField from "@components/input-field";
import { edoService } from "../../../services/edo.services";
import SelectField from "../../select-field";

export default function ModalEdoAuth({type, isShow, setIsShow, setIsNeedUpdate, onSuccess }) {
  const [loading, setLoading] = useState(false);

  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [typesList, setTypesList] = useState(null);
  const [fieldsErrors, setFieldsErrors] = useState({});
  const [typeName, setTypeName] = useState("-");

  const [tmpSession, setTmpSession] = useState(false);
  const [tmpKey, setTmpKey] =useState(false);
  const [confirmCode, setConfirmCode] = useState('');

  let bigButtonStyle = { width: '200px', height: '43px', background: '#1CAA53', position: 'static', borderRadius: '10px' };
  let confirmButtonStyle = { width: '200px', height: '43px', background: '#1CAA53', position: 'static', borderRadius: '10px', marginTop: 'auto' };

  useEffect(() => {
    if (!typesList && isShow) {
      setLoading(true);
      edoService.getTypes()
        .then((res) => {
          let reindexedData = {};
          res.map((type) => {
            reindexedData[type.Id] = type.Name;
          });

          setTypeName(reindexedData[type]);
          setLoading(false);
        })
        .catch((error) => {
          notification.error({
            message: "Получение данных о типах ЭДО", description: error,
          });
        });
    }
  }, [isShow]);

  const onSubmitFormEdoAuth = e => {
    e.preventDefault();
    setLoading(true);
    edoService.authByLogin(type, username, password)
      .then((response) => {
          setLoading(false);
          if (response.status === "success") {
            if(response.needConfirm || false) {
              notification.success({message: "Авторизация", description: response.message});
              setTmpSession(response.addInfo.ИдентификаторСессии);
              setTmpKey(response.addInfo.Идентификатор);
            } else {
              notification.success({message: "Авторизация", description: response.message});
              setIsNeedUpdate(true);
              closeAndClearModal();
            }
          } else if (response.status === "error"){
              setFieldsErrors(response.errors);
          }
      })
      .catch((error) => {
          notification.error({message: "Авторизация", description: error});
          setLoading(false);
      });
  };

  const onSubmitConfirmAuth = e => {
    e.preventDefault();
    setLoading(true);
    edoService.authConfirm(type, tmpSession, tmpKey, confirmCode)
      .then((response) => {
          setLoading(false);
          if (response.status === "success") {
              notification.success({message: "Авторизация", description: response.message});
              setIsNeedUpdate(true);
              closeAndClearModal();
          } else if (response.status === "error"){
              setFieldsErrors(response.errors);
          }
      })
      .catch((error) => {
          notification.error({message: "Авторизация", description: error});
          setLoading(false);
      });
  };

  const getFieldErrors = fieldName => {
    return typeof fieldsErrors[fieldName] !== "undefined"
      ? fieldsErrors[fieldName].reduce((fieldErrors, error) => {
          return fieldErrors + "; " + error;
        })
      : null;
  };

  const closeAndClearModal = () => {
    setTmpKey(false);
    setTmpSession(false);
    setConfirmCode('');
    setIsShow(false);
  }

  return (
    <Modal
      title={"Авторизация в " + typeName}
      cancelText="Закрыть"
      className="modal-window"
      align={null}
      visible={isShow}
      onCancel={() => {
        setIsNeedUpdate(true);
        closeAndClearModal();
      }}
      footer={[
        <Button htmlType="submit" key="submit" disabled={tmpSession} style={bigButtonStyle} type="primary" onClick={onSubmitFormEdoAuth}>
          Войти
        </Button>
      ]}
    >
      <Spin spinning={loading} tip="Загрузка...">
        <Form>
          <Row gutter={[16, 24]}>
            <Col span={24}>
              <InputField
                name="username" label="Email / Телефон"
                value={username} setValue={setUsername}
                getFieldErrors={getFieldErrors}
              />
            </Col>
            <Col span={24}>
              <InputField
                name="password" label="Пароль" type="password"
                value={password} setValue={setPassword}
                getFieldErrors={getFieldErrors}
              />
            </Col>
          </Row>
          {(tmpSession && tmpKey) &&
          <Row gutter={[16, 24]} style={{ display: 'flex', alignItems: 'stretch' }}>
            <Col span={12}>
              <InputField
                name="username" label="Код подтверждения"
                value={confirmCode} setValue={setConfirmCode}
                getFieldErrors={getFieldErrors}
              />
            </Col>
            <Col span={12} style={{display: 'flex', flexDirection: 'column', justifyContent: 'flex-end'}}>
              <Button htmlType="submit" key="submit" style={confirmButtonStyle} disabled={!confirmCode} type="primary" onClick={onSubmitConfirmAuth}>
                Отправить код
              </Button>
            </Col>
          </Row>}
        </Form>
      </Spin>
    </Modal>
  );
}
